export default {
  sKey: {
    IsShowGhiChu: "IsShowGhiChu",
    IsCauHinhT86: "IsCauHinhT86",
    IsCauHinhT77: "isCauHinhT77",
    DuNoGiamDanLaiGiamDan: "DuNoGiamDanLaiGiamDan",
    IsShowKieuTinhLai: "IsShowKieuTinhLai",
    IsQRThanhToan: "IsQRThanhToan",
    IsQuyTrinhPheDuyet: "isQuyTrinhPheDuyet",
    IsNangCapKHBinhAn: "IsNangCapKHBinhAn",
    IsNangCapKHVSNY: "IsNangCapKHVSNY",
    IsCauHinhThamDinhTaiSanBanChung: "IsCauHinhThamDinhTaiSanBanChung",
    IsShowGoiVay: "IsShowGoiVay",
    IsTaiKhoanIcloud: "IsTaiKhoanIcloud",
    SuDungMaNhanVien: "SuDungMaNhanVien",
    IsUseChuKySo: "isUseChuKySo",
    TyLePhiXuat: "TyLePhiXuat",
    ThueGTGT: "ThueGTGT",
    IsMoney88: "isMoney88",
    ChiPhiVayTraGop: "ChiPhiVayTraGop",
    IsPhanQuyenThongTinKhachHang: "isPhanQuyenThongTinKhachHang",
    IsWinmoney: "isWinmoney",
  },
};
